import styled from "styled-components";

import { CompanyMission } from "./CompanyMission";
import { CompanyJobs } from "./CompanyJobs";

import { Card, media } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";
import { DiversityInitiatives } from "@otta/search/components/DiversityInitiatives";
import { Company } from "@otta/search/schema";
import Visa from "@otta/search/components/Icons/Visa.svg";
import {
  Founders,
  PeopleProgressing,
} from "@otta/search/components/PeopleAtCompany";
import { CompanyArticles } from "@otta/search/components/CompanyArticles";
import { CompanyValues } from "@otta/search/components/CompanyValues";
import { CompanyAdditionalInfo } from "@otta/search/components/CompanyAdditionalInfo";
import { Insights } from "@otta/search/components/Insights";
import { OttasTake } from "@otta/search/components/OttasTake";
import { CompanyBenefitsList } from "@otta/search/components/CompanyBenefitsList";
import { CompanyFunding } from "@otta/search/components/CompanyFunding";
import { CompanyPhotos } from "@otta/search/components/CompanyPhotos";
import { IconFeature } from "@otta/search/components/IconFeature";

interface CompanyContentProps {
  company: Company.Company;
  userVisaRequirements: string[];
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;

  ${media({ from: "tablet" })`
    gap: ${pxToRem(24)};
  `}
`;

export const CompanyContent = ({
  company,
  userVisaRequirements,
}: CompanyContentProps): React.ReactElement => {
  const showVisa =
    company.visaSponsorshipCountries
      .filter(({ offersVisa }) => offersVisa)
      .some(l => userVisaRequirements.includes(l.location)) ||
    // TODO: Visa
    false;

  return (
    <Wrapper>
      <CompanyMission company={company} />
      <Card>
        <Insights company={company} />
      </Card>
      <Card>
        <OttasTake company={company} hasTitle />
      </Card>
      <Card>
        <CompanyBenefitsList company={company} />
      </Card>
      <Card>
        <CompanyValues company={company} />
      </Card>
      <Card>
        <CompanyFunding company={company} fromCompanyProfile />
      </Card>
      <Card>
        <Founders company={company} />
      </Card>
      <Card>
        <PeopleProgressing company={company} />
      </Card>
      <Card>
        <DiversityInitiatives company={company} />
      </Card>
      <Card>
        <CompanyArticles company={company} />
      </Card>
      <Card>
        <CompanyAdditionalInfo company={company} />
      </Card>
      <Card>
        <CompanyJobs company={company} />
      </Card>
      <Card>
        <CompanyPhotos company={company} fullWidth={false} />
      </Card>

      {showVisa && (
        <IconFeature
          icon={Visa}
          text={`${company.name} is able to sponsor visas, but that doesn't guarantee they are sponsoring for this role. Ask the hiring team for more information`}
        />
      )}
    </Wrapper>
  );
};
